import { render, staticRenderFns } from "./AlertLongStayListScreen.vue?vue&type=template&id=ae2b7dda&scoped=true&lang=pug"
import script from "./AlertLongStayListScreen.vue?vue&type=script&lang=ts"
export * from "./AlertLongStayListScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertLongStayListScreen.vue?vue&type=style&index=0&id=ae2b7dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2b7dda",
  null
  
)

export default component.exports